import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { Coordinates } from './LoadSiteData'
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import CHF from "assets/CHF.png";
import CHF1P from "assets/CHF1P.png";
import CHF2P from "assets/CHF2P.png";
import ZL from "assets/ZoneLog_Logger.png"
import { GutermannModelConverter } from "../../Utils/GutermannModelCoverter";
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import redMarker from '../../assets/mapLocationMarkers/pinRed.png';
import moment from 'moment'


export interface Site {
    id: number;
    siteNameUserFriendly: string;
    siteName: string;
    created: Date;
    deleted: Date | null;
    latitude: number | null;
    longitude: number | null;
    groups: Array<{ id: number; displayName: string }>;
    defaultSite: boolean;
    fkCompanyId: number;
    fkEASiteId: number | null;
    EASite: string;
    lastUpdate: Date | null;
    alarmState: number | null;
    alarmsEnabled: number | null;
    loggers: Array<APILoggerDetail>;
    lastReading?: Date | null;
    hasActiveLoggers?: string;
    boundary?: string;





}


export interface APISiteLoggerDetail extends APILoggerDetail {
    IsSiteOutput?: boolean
    CompanyName?: string
    hasGps: boolean | null
}

export interface RedirectProps {
    siteName: string;
    siteId: number | null;
    serial: string;
    deviceId: number | null;
}


export interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number | null
    id: number
    tooltip: Tooltip


}

interface Tooltip {
    model: string
    img: string
    deviceName: string | null
}

export interface BoundaryData {
    path: Array<Coordinates>
    styling: BoundaryStyling
}

export interface BoundaryStyling {
    strokeWeight: number
    strokeColor: string
    areaColor: string
    transparency: number
}

export const defaultCenter = window.location.hostname.includes("zonelog.net")
    ? { lat: 47.17442830752493, lng: 8.517189402835617 }
    : { lat: 50.744094943532446, lng: -3.99597602646894 };


export interface Company {
    name: string
    id: number
    isParent: boolean
}



export const reloadData = (


    setLoading: (loading:boolean) => void,
    siteId: number,
    setPolygonPath: (path: Coordinates[]) => void ,
    setSite: (site: Site) => void,
    setLoggerData: (loggerData: APISiteLoggerDetail[]) => void,
    setBoundaryStyle: (styling: BoundaryStyling) => void,
    setHasBoundary: (hasBoundary: boolean) => void,
    setMarkers: (markersData: GPS[]) => void,
    setLoggersToBeAssigned: () => void,
    setAuthorized: (auth: boolean) => void,
    startDate: Date,
    setLastDataDate: (date: Date) => void,
    setHistoricLoggerData: (historicData: APILoggerDetail) => void,
    setLoggerIds: (loggerIdData: number[]) => void



): void => {
    setLoading(true)
    const loggerIdsTemp: number[] | null = []
    console.log(siteId)
    CallGetAPI(CreateUrl('/api/aquaguard/site?id=' + siteId), {})
        .then((data: Site) => {
            console.log(data)
            setPolygonPath([])
            const markersTemp: GPS[] | null = []
            setLoggerData(data.loggers)
            if (data.loggers.length > 0) {
                data.loggers.forEach((logger: APILoggerDetail) => {
                    console.log(logger)
                    logger = buildAPILoggerDetail(logger)
                    console.log(logger)
                    let imgSrc = ""
                    if (logger.Model.slice(0, 2) === 'CH') {
                        imgSrc = CHF
                        if (logger.Model.includes('2P')) {
                            imgSrc = CHF2P
                        } else if (logger.Model.includes('1P')) {
                            imgSrc = CHF1P
                        }
                    }
                    console.log(logger)
                    markersTemp.push({
                        position: logger.Latitude && logger.Longitude ? { lat: logger.Latitude, lng: logger.Longitude } : { lat: defaultCenter.lat, lng: defaultCenter.lng },
                        key: logger.LoggerId,
                        serial: logger.Serial,
                        tooltip: {
                            model: window.location.hostname.includes('zonelog.net') ? GutermannModelConverter(logger.Model) : logger.Model,
                            img: window.location.hostname.includes('zonelog.net') ? ZL : imgSrc,
                            deviceName: logger.DeviceName
                        },
                        icon: logger.Latitude && logger.Longitude ? yellowMarker : redMarker

                    })
                    loggerIdsTemp.push(logger.LoggerId)
                    console.log(markersTemp)
                    console.log(logger)
                })
                console.log(data.loggers)
            }
            console.log(data)
            setSite(data)

            if (data.boundary) {
                const boundaryData: BoundaryData = JSON.parse(data.boundary)
                if (Array.isArray(boundaryData.path)) {
                    setPolygonPath(boundaryData.path)
                    setBoundaryStyle(boundaryData.styling)
                    setHasBoundary(true)
                }
            }

            setMarkers(markersTemp)

            if (loggerIdsTemp.length === 1) {
                sessionStorage.setItem('selectedLoggers', loggerIdsTemp[0].toString())
            } else if (loggerIdsTemp.length > 1) {

                sessionStorage.setItem('selectedLoggers', loggerIdsTemp.map(logger => logger.toString()).join())
            } else {
                sessionStorage.setItem('selectedLoggers', "")
            }

            CallGetAPI(CreateUrl('/api/aquaguard/SitesForCompany?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
                .then((data: Site[]) => {
                    const unAssignedLoggers = []
                    data.map(site => {
                        if (site.defaultSite) {
                            if (site.loggers.length > 0) {
                                site.loggers.forEach(logger => unAssignedLoggers.push(logger))
                            }
                            unAssignedLoggers.sort((a, b) => a.deploymentDate + b.deploymentDate)
                        }
                    })
                    setLoggersToBeAssigned(unAssignedLoggers)

                })
        })
        .catch(err => {
            setAuthorized(false)
            console.log(err)
        })
    //Historic Site Logger Info
    CallGetAPI(CreateUrl('/api/aquaguard/HistoryForSite?siteId=' + siteId), {})
        .then(data => {
            let lastDataDateTemp = moment(0)

            data.forEach(item => {
                if (item.endDate && moment(item.endDate).isSameOrAfter(moment(lastDataDateTemp))) {
                    lastDataDateTemp = item.endDate
                }
                if (item.endDate && moment(item.endDate).isAfter(moment(startDate))) {
                    loggerIdsTemp.push(item.loggerId)

                }
            })

            setLastDataDate(lastDataDateTemp)
            setHistoricLoggerData(data.filter(item => item.endDate !== null))
            setLoading(false)
        })
        .catch(err => console.error(err))
    setLoggerIds(loggerIdsTemp)
}


 